<template>
    <div class="app-logout">
      <b-overlay class="btn-next-overlay" spinner-small>
      <b-button v-on:click="logOut()" variant="primary"><slot name="lblButton">Logout</slot></b-button>
      </b-overlay>
    </div>
</template>

<script>
import logout from '../../../mixins/logout'

export default {
  name: 'LogOut',
  mixins: [
    logout
  ]
}
</script>
